import { Abi } from 'viem'
import { z } from 'zod'

const AbiInputSchema = z.object({
  name: z.string(),
  type: z.string(),
})

const AbiConstructorSchema = z.object({
  type: z.literal('constructor'),
  inputs: z.array(AbiInputSchema),
  stateMutability: z
    .union([z.literal('payable'), z.literal('nonpayable')])
    .optional(),
})

const AbiErrorSchema = z.object({
  type: z.literal('error'),
  name: z.string(),
  inputs: z.array(AbiInputSchema),
})

const AbiEventInputSchema = AbiInputSchema.extend({
  indexed: z.boolean(),
})

const AbiEventSchema = z.object({
  type: z.literal('event'),
  name: z.string(),
  inputs: z.array(AbiEventInputSchema),
  anonymous: z.boolean().optional(),
})

const AbiFallbackSchema = z.object({
  type: z.literal('fallback'),
  stateMutability: z.union([z.literal('payable'), z.literal('nonpayable')]),
  inputs: z.tuple([]).optional(),
})

const AbiOutputSchema = z.object({
  name: z.string(),
  type: z.string(),
})

const AbiFunctionSchema = z.object({
  type: z.literal('function'),
  name: z.string(),
  inputs: z.array(AbiInputSchema),
  outputs: z.array(AbiOutputSchema),
  stateMutability: z.union([
    z.literal('pure'),
    z.literal('view'),
    z.literal('payable'),
    z.literal('nonpayable'),
  ]),
})

// ABI receive schema
const AbiReceiveSchema = z.object({
  type: z.literal('receive'),
  stateMutability: z.literal('payable'),
  inputs: z.tuple([]).optional(),
})

export const AbiItemSchema = z.union([
  AbiConstructorSchema,
  AbiErrorSchema,
  AbiEventSchema,
  AbiFallbackSchema,
  AbiFunctionSchema,
  AbiReceiveSchema,
])

export function assertViemAbiItemArray(obj: any): asserts obj is Abi {
  try {
    Array.isArray(obj) && obj.every(element => AbiItemSchema.parse(element))
  } catch (error) {
    throw new Error(`Expected an array of AbiItem: ${error}`)
  }
}
